import { retry } from '../../../shared/lib/retry.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type { CommonDeps } from '../base/CommonDeps'

export type NotificationSubjects = {
    scheduledInstances?: UUID[]
    postEvents?: UUID[]
    comments?: UUID[]
    notificationIds?: UUID[]
}

export async function tryMarkNotificationsAsRead(
    deps: CommonDeps,
    subjects: NotificationSubjects,
    syncNotifications?: () => Promise<void>
) {
    try {
        // Can't guarantee we have internet connection so if failed, retry a few times
        await retry(5, async () => {
            await deps.httpClient.markNotificationsAsRead(
                subjects.comments ?? [],
                subjects.postEvents ?? [],
                subjects.scheduledInstances ?? [],
                subjects.notificationIds ?? []
            )
        })

        // Sync notifications on the app
        if (syncNotifications) {
            await syncNotifications()
        }
    } catch (error) {
        /* eslint-disable-next-line no-console */
        console.log(error)
        deps.reportError(error)
    }
}
